<template>
  <div class="signature-safe-payment mt-6">
    <div class="security-info mb-3">
      <div class="item" style="text-align: left">Todas cobranças são intermediadas pelo Banco Asaas</div>
      <div class="item"><img :src="require('@/assets/asaas.svg')" /></div>
      <div class="item"><img :src="require('@/assets/compra-100-segura.svg')" /></div>
    </div>
    <p>
      Utilizamos as mais avançadas medidas de segurança, incluindo criptografia de ponta a ponta, para proteger seus dados. Sua privacidade é
      primordial e seus detalhes de pagamento nunca são compartilhados.
    </p>
  </div>
</template>
<script>
export default {
  name: 'SignatureSafePaymentSection'
};
</script>
<style lang="scss">
.signature-safe-payment {
  .security-info {
    padding: 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e1e4e6;
    border-left: 0;
    border-right: 0;
    gap: 12px;

    color: #3f505f;
    font-size: 11px;
    font-weight: 600;

    .item {
      flex: 1 1 0;
      width: 0;
      text-align: center;
    }
  }
  p {
    color: #6e7481;
    font-size: 12px;
    font-weight: 400;
  }
}
</style>
